import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { css } from '@styled-system/css';
import React__default from 'react';
import styled from 'styled-components';
import { compose, space, color, typography, layout, background, border, position, shadow } from 'styled-system';
import { useBreakpointValue } from '../../hooks/useBreakpointValue.js';
import '../provider/WindowSizeContext.js';
import '../provider/ColorModeContext.js';
import 'copy-to-clipboard';
import 'lodash/isEqual';

var StackWrapper = styled.div(function (_a) {
    var childrenMarginTop = _a.childrenMarginTop, childrenMarginBottom = _a.childrenMarginBottom, childrenMarginRight = _a.childrenMarginRight, childrenMarginLeft = _a.childrenMarginLeft, align = _a.align, justify = _a.justify, direction = _a.direction;
    return css({
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        "& > * + *": {
            marginTop: childrenMarginTop,
            marginBottom: childrenMarginBottom,
            marginLeft: childrenMarginLeft,
            marginRight: childrenMarginRight,
        },
    });
}, compose(space, color, typography, layout, background, border, position, shadow));
var Stack = React__default.forwardRef(function (_a, ref) {
    var align = _a.align, justify = _a.justify, spacing = _a.spacing, _b = _a.direction, direction = _b === void 0 ? "row" : _b, children = _a.children, rest = __rest(_a, ["align", "justify", "spacing", "direction", "children"]);
    var computedDirection = useBreakpointValue(direction);
    return (React__default.createElement(StackWrapper, __assign({}, rest, { childrenMarginTop: computedDirection === "column" ? spacing : 0, childrenMarginBottom: computedDirection === "column-reverse" ? spacing : 0, childrenMarginLeft: computedDirection === "row" ? spacing : 0, childrenMarginRight: computedDirection === "row-reverse" ? spacing : 0, align: align, justify: justify, direction: computedDirection, ref: ref }), children));
});
var HStack = React__default.forwardRef(function (props, ref) { return (React__default.createElement(Stack, __assign({ align: "center" }, props, { direction: "row", ref: ref }))); });
var VStack = React__default.forwardRef(function (props, ref) { return (React__default.createElement(Stack, __assign({ align: "center" }, props, { direction: "column", ref: ref }))); });

export { HStack, Stack, VStack };
//# sourceMappingURL=Stack.js.map
